import { HereMapInterface } from 'common/utils/Map';

import clusterLayerCreator from 'common/utils/MapMarker/GoogleMarker/utils/clusterLayerCreator';
import markerLayerCreator from 'common/utils/MapMarker/GoogleMarker/utils/markerLayerCreator';

import {
  MapMarker,
  OverlayProps,
  MapMarkerLayer
} from '../types';


export class HereMarker implements MapMarker {
  private _map: HereMapInterface;

  constructor(map?: HereMapInterface) {
    this._map = map as HereMapInterface;
  }

  updateLayers(layers: MapMarkerLayer[]) {
    this._map?.overlay?.setProps({
      layers: layers.map(layer => (
        layer.type === 'cluster'
          ? clusterLayerCreator(layer)
          : markerLayerCreator(layer)
      ))
    });
  }

  deleteMarker() {}

  setOverlayProps(props: OverlayProps) {}

  addClickHandler(handler: MapMarkerLayer['onClick']) {
  }

  deleteClickHandler(handler: MapMarkerLayer['onClick']) {
  };
}